module.exports = __webpack_public_path__ + "img/Loading_akkodis_logo_3.175bcea6.svg";